/** Year picker span - must stay divisible by 3 so the grid always fills 3 columns. */
export const EMPLOYMENT_YEAR_SPAN = 75;

/** Shared by the picker bounds and the schema so both reject the same dates. */
export const getEmploymentDateBounds = () => {
	const maxDate = new Date();
	const minYear = maxDate.getFullYear() - EMPLOYMENT_YEAR_SPAN + 1;

	return {
		minDate: new Date(minYear, 0, 1),
		maxDate,
	};
};
